import React from "react";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2)
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1)
  }
}));

interface modalProps {
  open: boolean;
  setOpen: (arg0: boolean) => void;
  children: any;
  fullWidth?: boolean;
}

const Modal: React.FC<modalProps> = ({
  open = false,
  setOpen = () => {},
  children = "",
  fullWidth = false
}) => {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth={fullWidth}
      >
        {children}
      </BootstrapDialog>
    </div>
  );
};
export default Modal;
